import { AclRole } from './acl-role';
import { Account } from './account';
import { IObject } from './object';
import { Environment } from './environment';


export interface AclEntry {
  id: number;
  aclRoleIds?: number;
  aclRole?: AclRole;
  accountId?: number;
  account?: Account;
  objectId?: number;
  object?: IObject;
  environmentId?: number;
  environment?: Environment;
}
